import { TabMenuItemGeneral, TabMenuItemProps, TabMenuItemResult } from './TabMenuItem';

export const isResultTab = (props: TabMenuItemProps): props is TabMenuItemResult => props.type === 'result';
export const isGeneralTab = (props: TabMenuItemProps): props is TabMenuItemGeneral => props.type === 'general';
